'use client';

import { useTranslations } from 'next-intl';
import { useState } from 'react';

import { BannerHero } from '@payload-types';

import ArrowLeftIcon from '@/fo/icons/base/icons/arrow.svg';
import { UiKitBannerHero } from '@/fo/ui/kit/banner/hero';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { BreadcrumbsItem } from '@/fo/util/map-product-data';

import { Sidebar } from '../components/Sidebar/Sidebar';

import { styles } from './FeatureHelpPageBase.styles';

type NativeElement = React.HTMLAttributes<HTMLDivElement>;
export interface FeatureHelpPageBaseProps {
  children?: React.ReactNode;
  onClick?: NativeElement['onClick'];
  title: string;
  sidebar: {
    title: string;
    url: string;
  }[];
  banners: BannerHero['banners'] | null | undefined;
}

export function FeatureHelpPageBase({
  children,
  banners,
  title,
  sidebar,
  ...props
}: FeatureHelpPageBaseProps) {
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const slots = styles({ openMenu: isOpenMenu });

  const t = useTranslations();

  const breadcrumbs: BreadcrumbsItem[] = [
    {
      label: t('HomePage'),
      href: '/'
    },
    {
      label: title
    }
  ];

  const handleOpen = () => {
    setIsOpenMenu(true);
  };

  const handleActiveClick = () => {
    setIsOpenMenu(false);
  };

  return (
    <div className={slots.wrapper()}>
      {Array.isArray(banners) && banners.length > 0 && banners[0] && (
        <UiKitBannerHero
          className={slots.banners()}
          type="category"
          bannerMain={true}
          banners={[
            {
              mode: banners[0]?.mode || undefined,
              image: {
                sm:
                  typeof banners[0].image === 'object'
                    ? banners[0].image.sizes?.mobile?.url ||
                      banners[0].image.sizes?.desktop?.url ||
                      banners[0].image.url ||
                      ''
                    : '',
                md:
                  typeof banners[0].image === 'object'
                    ? banners[0].image.sizes?.desktop?.url ||
                      banners[0].image.sizes?.mobile?.url ||
                      banners[0].image.url ||
                      ''
                    : ''
              },
              title: banners[0].title,
              buttons: [],
              buttonText: '',
              link: ''
            }
          ]}
          breadcrumbs={{
            items: breadcrumbs
          }}
        />
      )}
      <div
        className={slots.base()}
        {...props}
      >
        <Sidebar
          className={slots.sidebar()}
          data={sidebar}
          onActiveClick={handleActiveClick}
        />
        <div className={slots.back()}>
          <UiKitButtonBase
            color="transparent"
            onClick={handleOpen}
            className={slots.backButton()}
          >
            <ArrowLeftIcon className={slots.backIcon()} />
            <span className={slots.backText()}>{t('back')}</span>
          </UiKitButtonBase>
        </div>
        <div className={slots.contentContainer()}>
          <h2 className={slots.title()}>{title}</h2>
          {children}
        </div>
      </div>
    </div>
  );
}
